import { render } from "./AboutText.vue?vue&type=template&id=6e9766be&scoped=true"
import script from "./AboutText.vue?vue&type=script&lang=js"
export * from "./AboutText.vue?vue&type=script&lang=js"

import "./AboutText.vue?vue&type=style&index=0&id=6e9766be&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\travelsite-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9766be"]])

export default __exports__